import { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './privatebank/Header';
import Footer from './privatebank/Footer';
import Home from './privatebank/Home';
import Practice from './privatebank/Practice';
import HouseView from './privatebank/HouseView';
import Introduce from './privatebank/Introduce';

export default function PrivateBankTemplate() {
  const [page, setPage] = useState('home');
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [page]);
  return (
    <div className="min-h-screen bg-[#EFEAE0]" data-testid="bank-template-root">
      <Header page={page} setPage={setPage} />
      <AnimatePresence mode="wait">
        <motion.main key={page} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.4 }} data-testid={`bank-page-${page}`}>
          {page === 'home' && <Home setPage={setPage} />}
          {page === 'practice' && <Practice setPage={setPage} />}
          {page === 'view' && <HouseView setPage={setPage} />}
          {page === 'introduce' && <Introduce setPage={setPage} />}
        </motion.main>
      </AnimatePresence>
      <Footer setPage={setPage} />
    </div>
  );
}
